import ReactSpeedometer from "react-d3-speedometer"
import { useState, useEffect } from "react";
import { connect } from "react-redux";

function KwhNowStatsSpeedo(props) {
  const [meterValue, setMeterValue] =useState("");

  let meterData = (meterValue/1000).toFixed(2);

  let maxMeterValue = (Number(props.widget.params._attributes.max_hourly_w)/1000);

  let meterResult = meterData >= 9999 ? 9999 : meterData;

  useEffect(() => {
    if (props.powerData) {
       if(props.powerData.meter===props.widget.params._attributes.meterno){
         setMeterValue(props.powerData.current_power);
       }
    }
  }, [props.powerData]);




    return (
        <div style={{ marginTop: '10px'}}>
            <ReactSpeedometer 
                labelFontSize={'14px'}
                valueTextFontSize={'16px'}
                paddingHorizontal={4}
                paddingVertical={4}
                maxValue={maxMeterValue}
                value={meterResult >= maxMeterValue ? maxMeterValue : meterResult}
                needleColor="#969696"
                needleHeightRatio={0.70}
                currentValueText= {`${meterResult} kW`}
                needleTransitionDuration={3000}
                segmentColors={["#85cb06", "#f0c20a"]}
                segments={2}
                textColor="#fff"
                ringWidth={6}
                width={170}
                height={110}
               dimensionUnit="px"
                
/>
        </div>
    );
}

const mapStateToProps = (state) => ({
  cbusEvent: state.reducer.cbusEvent,
});


export default connect(mapStateToProps)(KwhNowStatsSpeedo);